import { BasketAddItemOptions, BasketResponse, NormalisedBasketResponse } from 'types/BasketTypes';
import { BasketServiceInterface } from '../interface/BasketServiceInterface';

export default class ATGBasketService implements BasketServiceInterface {
  async addItem({
    item,
    csrfToken,
    sessionConfirmationNumber,
  }: BasketAddItemOptions): Promise<NormalisedBasketResponse> {
    const { variantId, personalisation, selectedAddOnServices, warrantyOptionNumber } = item;

    const requestBody: {
      variantId: string;
      personalisation?: string;
      warrantyOptionNumber?: string;
      selectedAddOnServices?: string[];
    } = {
      variantId,
    };

    if (personalisation) {
      requestBody.personalisation = personalisation;
    }

    if (warrantyOptionNumber) {
      requestBody.warrantyOptionNumber = warrantyOptionNumber;
    }

    if (selectedAddOnServices) {
      requestBody.selectedAddOnServices = selectedAddOnServices;
    }

    const response = await fetch(
      `/rest/model/atg/commerce/order/purchase/CartModifierActor/addVariantToOrder?_dynSessConf=${sessionConfirmationNumber}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': csrfToken!,
        },
        method: 'POST',
        body: JSON.stringify(requestBody),
      },
    );

    const data = (await response.json()) as BasketResponse;

    return {
      success: response.ok,
      status: response.status,
      statusText: response.statusText,
      ...data,
    };
  }
}
